import schemaAssetView from './schemaAssetView';
import schemaDashboardTemplate from './schemaDashboardTemplate';
import schemaEntityView from './schemaEntityView';
import schemaOntology from './schemaOntology';
import schemaStartPageView from './schemaStartPageView';
import schemaUploadTemplate from './schemaUploadTemplate';

interface TpTemplateTypeInfo {
  id: string;
  id2: string; // NOTE: we are using two types of identifiers, depending on the code. id2 captures the second identifier
  name: string;
  yamlSchema: object;
}

export const templateTypeList: TpTemplateTypeInfo[] = [
  {
    id: 'ontology',
    id2: 'ontologies',
    name: 'Ontology',
    yamlSchema: schemaOntology,
  },
  {
    id: 'asset',
    id2: 'assetViews',
    name: 'Asset View',
    yamlSchema: schemaAssetView,
  },
  {
    id: 'entity',
    id2: 'entityViews',
    name: 'Entity View',
    yamlSchema: schemaEntityView,
  },
  {
    id: 'start_page',
    id2: 'startPageViews',
    name: 'Start Page View',
    yamlSchema: schemaStartPageView,
  },
  {
    id: 'dashboard',
    id2: 'dashboardTemplates',
    name: 'Dashboard Template',
    yamlSchema: schemaDashboardTemplate,
  },
  {
    id: 'upload',
    id2: 'uploadTemplates',
    name: 'Upload Templates',
    yamlSchema: schemaUploadTemplate,
  },
];

const templateTypeMapById: { [id: string]: TpTemplateTypeInfo } = {};
for (const templateType of templateTypeList) {
  templateTypeMapById[templateType.id] = templateType;
}

function isRenderingType(scope: string) {
  return scope !== 'ontology';
}

/**
 * The schemas defined above represent the templateContent field of the actual stored templates.
 * Wrap those schemas with the outer rendering schema representation
 * @param scope: scope of the template. Enforce this constant value.
 * @param type: type of the template, related to the asset. Enforce this constant value.
 * @param templateContentSchema : templateContent data
 */
function renderingTemplateSchema(scope: string, type: string, templateContentSchema: object) {
  return {
    type: 'object',
    properties: {
      templateContent: templateContentSchema,
      templateScope: { type: 'string', const: scope },
      templateType: { type: 'string', const: type },
    },
    required: ['templateContent', 'templateScope', 'templateType'],
  };
}

/**
 * Get the template definition & schema by ID (scope)
 *
 * @param id: id (scope) of the template
 * @param resourceType: type related to ingestion or asset
 */
export function getTemplateTypeById(id: string, resourceType: string): TpTemplateTypeInfo {
  if (!templateTypeMapById[id]) throw `Invalid template type: ${id}`;
  const templateType = templateTypeMapById[id];

  // Update the schema by wrapping it in the rendering template schema
  if (isRenderingType(id)) {
    return {
      ...templateType,
      yamlSchema: renderingTemplateSchema(id, resourceType, templateType.yamlSchema),
    };
  }

  return templateType;
}
